<template>
  <div class="repair-record">
    <breadcrumb :breadcrumb="breadcrumb"/>

    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <div class="btn-box">
          <span style="margin-right: 0.06rem">申请时间</span>
          <el-date-picker
            v-model="timeValue"
            :picker-options="pickerOptions2"
            end-placeholder="结束日期"
            range-separator="至"
            size="small"
            start-placeholder="开始日期"
            type="daterange"
            unlink-panels
            value-format="yyyy-MM-dd"
            @change="changeTimeValue">
          </el-date-picker>
        </div>
<!--        <input-select :selectData="statusList" :selectKey="'status'" selectTitle="状态" style="margin-left: 10px;" @search="search"/>-->
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="入住人/入住房间" @search="searchKey"/>
<!--        <button-export-->
<!--          v-if="permissionCodes.indexOf('011002001') !== -1"-->
<!--          :beforeDownload="beforeDownload"-->
<!--          :href="exportUrl"-->
<!--          download="download.xls"-->
<!--          value="导出"/>-->
      </div>
    </div>
    <table-main
      :pageNum="requestData.pageNum"
      :pageSize="requestData.pageSize"
      :selection="false"
      :tableData="tableData"
      :tableHead="tableHead"
      :total="total"
      :has-operation="false"
      @changePagination="changePagination"
      @changeSelection="changeSelection"
      @toCurrentPage="toCurrentPage"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import {api} from "../../api/RepairManagement";
import {errorHandler} from "../../../utils/errorHandler";
import {nAlert, nSuccess} from "../../../utils/notice";
import {bus} from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "checkInApplication",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {value: "酒店入住", name: "check-in-application"},
        {value: "入驻申请"}
      ],
      exportUrl: "",
      statusList: [
        {key: "", label: "全部"},
        {key: "1", label: "待处理"},
        {key: "2", label: "已派单"},
        {key: "3", label: "处理中"},
        {key: "4", label: "待付款"},
        {key: "5", label: "待评价"},
        {key: "6", label: "已完结"}
      ],
      tableHead: [
        {prop: "personName", label: "入住人"},
        {prop: "checkTime", label: "入住时间"},
        {prop: "roomInfoNumber", label: "入住房间"},
        {prop: "applicationTime", label: "申请时间"},
        {prop: "statusText", label: "审批状态", showColor: true},
        {prop: "approveTime", label: "审批时间"},
        {prop: "approveName", label: "审批人"},
      ],
      tableData: [
        {
          code: '0111',
          personName: '张三',
          checkTime: '2024-03-20 12:25:12',
          roomInfoNumber: '301',
          applicationTime: '2024-03-20 12:20:12',
          statusText: '已通过',
          approveTime: '2024-03-20 12:21:12',
          approveName: '李四',
          fontColorToPeople: "#44C23B"
        },
        {
          code: '0112',
          personName: '李思',
          checkTime: '2024-03-19 12:25:12',
          roomInfoNumber: '203',
          applicationTime: '2024-03-19 12:20:12',
          statusText: '已驳回',
          approveTime: '2024-03-19 12:21:12',
          approveName: '李四',
          fontColorToPeople: "#f54659"
        },
        {
          code: '0113',
          personName: '王晓',
          checkTime: '2024-03-18 12:25:12',
          roomInfoNumber: '315',
          applicationTime: '2024-03-18 12:20:12',
          statusText: '已通过',
          approveTime: '2024-03-18 12:21:12',
          approveName: '李四',
          fontColorToPeople: "#44C23B"
        }
      ],
      total: 0,
      selectionArr: [],
      timeValue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      requestData: {
        status: "",
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },

      drawer: false,
      drawerData: {}
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreateTime();
  },
  activated() {
    this.getPage()
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-01";
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    beforeDownload() {
      if (this.timeValue.length > 0) {
        this.exportUrl = `${api.exportRepairCategory}?yq-app-code=${
          bus.global.yqCode
        }&token=${bus.global.token}&searchKey=${
          this.requestData.searchKey
        }&status=${this.requestData.status}&startTime=${
          this.timeValue[0]
        } 00:00:00&endTime=${this.timeValue[1]} 23:59:59`;
      } else {
        this.exportUrl = `${api.exportRepairCategory}?yq-app-code=${
          bus.global.yqCode
        }&token=${bus.global.token}&searchKey=${
          this.requestData.searchKey
        }&status=${this.requestData.status}`;
      }
    },
    changeTimeValue() {
      this.requestData.pageNum = 1;
      this.requestData.pageSize = 10;
      this.getPage();
    },
    getPage() {
      return;
      let reqData = this.requestData;
      if (this.timeValue && this.timeValue.length > 0) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`;
        reqData.endTime = `${this.timeValue[1]} 23:59:59`;
      } else {
        reqData.startTime = "";
        reqData.endTime = "";
      }
      this.$axios
        .post(api.getRepairRecordPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.status === "1") {
                v.statusText = "待处理";
                v.fontColorToPeople = "#FC5A5A";
                v.backgroundColor = "#FAECEC";
              } else if (v.status === "2") {
                v.statusText = "已派单";
                v.fontColorToPeople = "#8B36EF";
                v.backgroundColor = "#F1E8FC";
              } else if (v.status === "3") {
                v.statusText = "处理中";
                v.fontColorToPeople = "#EA9128";
                v.backgroundColor = "#FDF3E7";
              } else if (v.status === "4") {
                v.statusText = "待付款";
                v.fontColorToPeople = "#1362FF";
                v.backgroundColor = "#EAF0FF";
              } else if (v.status === "5") {
                v.statusText = "待评价";
                v.fontColorToPeople = "#50B5FF";
                v.backgroundColor = "#EAF5FF";
              } else if (v.status === "6") {
                v.statusText = "已完结";
                v.fontColorToPeople = "#18887B";
                v.backgroundColor = "#E4F0EF";
              }
              if (v.scene === "1") {
                v.sceneText = "个人报修";
              } else if (v.scene === "2") {
                v.sceneText = "公区报修";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取报修类别失败"));
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/repair_record_current/${code}`
      });
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的报修类别");
        return false;
      } else {
        this.$confirm("是否确认删除报修类别？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteRepairCategoryByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除报修类别失败"));
    },

    handleClose(done) {
      done();
    },
    // 返回
    personDataToWindowLeft() {
      this.drawer = false;
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.repair-record {
  form {
    width: 450px;
    margin: 0 auto;
    text-align: left;
  }

  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .line-text {
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }

  .line-info {
    width: 220px;
  }

  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }

    .el-icon-back:hover {
      color: #00a0e6;
    }

    .all-table-class .el-table td {
      padding: 10px 0;
    }

    form {
      position: relative;

      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }

      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 90px;
        line-height: 90px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/hotelCheckIn/checkInApplication/checkInApplication.vue